export const CASES_MERGED_EVENT = "casesMerged";
